import { Controller } from "@hotwired/stimulus"

const getAccountLocale = (key, account) => {
  window.allLocales = window.allLocales ? window.allLocales : {}
  
  if (!key) return "";
  window.allLocales[key] = 1;

  const readableKey = key.replace(/-|_/g, " ");
  if (!account) return readableKey;
  const { locales } = account;
  if (!locales) return readableKey;

  const defaultLocales = locales.find((lc) => lc.active && lc.is_default) || locales.find((lc) => lc.active);
  
  let browserLocales = locales.find(
    (lc) => lc.langcode === navigator.language
  );
  if (!browserLocales) {
    browserLocales = navigator.languages.length > 1
      ? locales.find((lc) => lc.langcode === navigator.languages[1])
      : null;
  }
  if (!browserLocales) {
    browserLocales = navigator.languages.length > 2
        ? locales.find((lc) => lc.langcode === navigator.languages[2])
        : null;
  }
  
  if (!browserLocales) {
    browserLocales = defaultLocales;
  }

  if (!browserLocales || !browserLocales.locales[key]) return readableKey;

  return browserLocales.locales[key] || readableKey;
}

const getLocale = (key, locales) => {
  return getAccountLocale(key, {locales})
}

const getWDay = () => {
  const weeks = [
    'sun',
    'mon',
    'tue',
    'wed',
    'thu',
    'fri',
    'sat',
  ]
  const wday = weeks[(new Date()).getDay()];
  const ele = document.querySelector(`.cbmap-wday-${wday}`);
  if (ele) ele.classList.add('cbmap-today');
}

export default class extends Controller {
  connect() {
    getWDay();
    const titleEle = document.querySelector('title')
    if(titleEle)  titleEle.textContent = 'Store Locator';

    const $lcEle = document.querySelector('#account-locale-languages');
    if(!$lcEle || !$lcEle.textContent) return true 
    const locales = JSON.parse($lcEle.textContent);
    // console.log(locales);
    document.querySelectorAll('[data-locale-text]').forEach((el) => {
      el.innerHTML = getLocale(el.dataset.localeText, locales);  
    })
  }
}
